import { useId } from 'vue'

import type { JWT } from '@/types/Common'

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    return JSON.parse(atob(token.split('.')[1]))
}

export const generateRandomId = (prefix = ''): string => {
    prefix = prefix ? `${prefix}-` : ''
    return `${prefix}${useId()}`
}

export const objectKeys = <T extends object>(obj: T) => {
    return Object.keys(obj) as (keyof T)[]
}

export const nullDate = '0001-01-01'
export const MongoDBNullId = '000000000000000000000000'
